export const subHeaderMenuList = [
  {
    label: 'HOME',
    items: [{ menu: 'notMenu', link: '/' }],
  },
  {
    label: 'DATA',
    items: [{ menu: 'notMenu', link: '/data' }],
  },
  {
    label: 'VIZ GALLERY',
    items: [{ menu: 'notMenu', link: '/visualization-gallery' }],
  },
  {
    label: 'HELP/SUPPORT',
    items: [
      { menu: 'About CAMPD', link: '/help-support/about' },
      { menu: 'Tutorials', link: '/help-support/tutorials' },
      { menu: 'FAQs', link: '/help-support/faqs' },
      { menu: 'Glossary', link: '/help-support/glossary' },
      { menu: 'Related Resources', link: '/help-support/related-resources' },
      { menu: 'Contact Us', link: '/help-support/contact-us' },
    ],
  },
];
